import Round4GameManager from './Round4GameManager';

class GameManager extends Round4GameManager {}

export default GameManager;
